export function AuthLayout({ children }: { children: React.ReactNode }) {
    return (
        <div className="bg-muted flex min-h-svh min-w-svw flex-col items-center justify-center gap-6 p-6 md:p-10">
            <div className="flex w-full max-w-sm flex-col gap-6">{children}</div>
        </div>
    );
}
